module.exports = __webpack_public_path__ + "85326a24d35d0045aeffe785d0662c28.svg";